import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Stack = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.61539 1.3478C7.86155 1.24523 8.13847 1.24523 8.38462 1.3478L14.2885 3.80773C14.568 3.92419 14.75 4.19727 14.75 4.50004C14.75 4.80282 14.568 5.0759 14.2885 5.19235L8.38462 7.65228C8.13847 7.75485 7.86155 7.75485 7.61539 7.65228L1.71155 5.19235C1.43206 5.0759 1.25001 4.80282 1.25001 4.50004C1.25001 4.19727 1.43206 3.92419 1.71155 3.80773L7.61539 1.3478ZM8.00001 2.81254L3.95001 4.50004L8.00001 6.18754L12.05 4.50004L8.00001 2.81254Z"
      fill="currentColor"
    />
    <path
      d="M7.64103 11.1655L1.23077 8.70005L1.76924 7.30003L8.00001 9.69648L14.2308 7.30003L14.7692 8.70005L8.35899 11.1655C8.12792 11.2544 7.8721 11.2544 7.64103 11.1655Z"
      fill="currentColor"
    />
    <path
      d="M1.23077 12.2001L7.64103 14.6655C7.8721 14.7544 8.12792 14.7544 8.35899 14.6655L14.7692 12.2001L14.2308 10.8L8.00001 13.1965L1.76924 10.8L1.23077 12.2001Z"
      fill="currentColor"
    />
  </Icon>
));

export default Stack;
